import { Flex, Button, useToast } from "@chakra-ui/react";
import {
  getSubscriptionStatus,
  getCurrentSubscription,
} from "@syla/shared/types/helpers/subscriptions";
import React, { useState } from "react";
import { useLocation } from "react-router-dom";
import { errorToastOptions } from "../components/molecules/errorToastOptions";
import { getFullPageUrl } from "../helper/getFullPageUrl";
import { redirectTo } from "../helper/RedirectTo";
import { useNavigator } from "../routers/navigator";
import { useMutationCreateStripeBillingPortalSession } from "../store/useMutationCreateStripeBillingPortalSession";
import { Subscription } from "../types/plans/subscription";
import { captureRequestError } from "../helper/captureRequestError";
import { SettingLabel } from "./Settings";

export const SettingsSubscriptionStatus = ({
  subscriptions,
}: {
  subscriptions: Subscription[];
}) => {
  const location = useLocation();
  const navigate = useNavigator();
  const errorToast = useToast(errorToastOptions);

  const [redirecting, setRedirecting] = useState<boolean>(false);

  const { mutateAsync: createStripeBillingPortalSession } =
    useMutationCreateStripeBillingPortalSession();

  const currentSub = getCurrentSubscription(subscriptions);
  const currentSubStatus = currentSub && getSubscriptionStatus(currentSub);

  const renewStatus = currentSubStatus?.cancelled
    ? currentSubStatus?.expired
      ? `Expired`
      : `Expires`
    : "Renews on";

  const subStatus = currentSubStatus?.valid
    ? `${renewStatus} ${currentSubStatus.endDate.toLocaleDateString()}`
    : "Action Required";

  const subInfoString = currentSub
    ? `${currentSub.plan.name} Plan (${subStatus})`
    : "No current Plan";

  return (
    <>
      <SettingLabel>{subInfoString}</SettingLabel>
      <Flex alignItems="end" direction="row">
        {currentSub && currentSub.stripeSubscriptionId && (
          <Button
            mr="10px"
            disabled={redirecting}
            isLoading={redirecting}
            onClick={async () => {
              try {
                setRedirecting(true);
                const response = await createStripeBillingPortalSession({
                  returnUrl: getFullPageUrl(location),
                  selectedPlanId: currentSub.plan._id,
                });
                redirectTo(response.portalUrl);
              } catch (error) {
                setRedirecting(false);
                captureRequestError(error);
                errorToast({
                  title: "Error managing plan",
                  description:
                    "An unexpected error occurred. Please try again later.",
                });
              }
            }}
          >
            Manage
          </Button>
        )}
        {(!currentSubStatus ||
          currentSubStatus.valid ||
          currentSubStatus.expired) && (
          <Button
            disabled={redirecting}
            onClick={() =>
              navigate({
                pathname: "/plans",
                state: {
                  referringUrl: getFullPageUrl(location),
                },
              })
            }
          >
            {currentSub
              ? currentSubStatus?.expired
                ? "Renew"
                : "Upgrade"
              : "Purchase"}
          </Button>
        )}
      </Flex>
    </>
  );
};
